import { Trans } from 'react-i18next';
import React from 'react';
import { getCurrentEnvironment } from '../apiEndpoint/apiEndpoint.js';
import styles from './translationUtils.module.scss.js';

var displayKey = function displayKey(key, i18inst) {
  var _window$location;
  var isTestEnv = getCurrentEnvironment((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) === 'test';
  if (i18inst.language === 'ID' && isTestEnv) {
    return key;
  }
  return null;
};
var translate = function translate(key, options, interpolationOptions, i18inst) {
  if (typeof key === 'undefined') {
    return i18inst.t(key, options, interpolationOptions);
  }
  var cKey = "".concat(key, "-").concat(JSON.stringify(options));
  var value = i18inst.t(key, options, interpolationOptions);
  if ((value === null || value === void 0 ? void 0 : value.indexOf('\n')) === -1) {
    return value;
  }
  var translation = [/*#__PURE__*/React.createElement("span", {
    key: cKey,
    className: styles.wrap
  }, value)];
  translation.toString = function () {
    return value;
  };
  return translation;
};
var tGeneric = function tGeneric(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var interpolationOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18inst = arguments.length > 3 ? arguments[3] : undefined;
  return displayKey(key, i18inst) || translate(key, options, interpolationOptions, i18inst);
};
var TLocGeneric = function TLocGeneric(key) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var interpolation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18inst = arguments.length > 3 ? arguments[3] : undefined;
  return displayKey(key, i18inst) || /*#__PURE__*/React.createElement(Trans, {
    i18n: i18inst,
    i18nKey: key,
    values: values,
    interpolation: interpolation,
    components: {
      ul: /*#__PURE__*/React.createElement("ul", {
        className: styles.bullet
      }),
      ol: /*#__PURE__*/React.createElement("ol", {
        className: styles.numbered
      })
    }
  });
};

export { TLocGeneric, tGeneric };
